module.exports = __webpack_public_path__ + "static/media/edit-organization.be91530d.svg";